import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { EuiLink } from '@equipmentshare/ds2'
import { heapEvent } from '@equipmentshare/heaper'

export type PartNumberProps = {
	item: {
		id: number,
		part?: { partNumber: string },
	},
}

export default function PartNumber( { item }: PartNumberProps ) {
	const navigate = useNavigate()
	const onClick = useCallback( () => {
		heapEvent( 'Inventory - Inventory Table - Click - Item Detail', {} )
		navigate( `/item/${item.id}` )
	}, [ item ] )
	const partNumber = item.part?.partNumber

	return (
		<EuiLink onClick={onClick}>{partNumber}</EuiLink>
	)
}
